export default __webpack_public_path__ + "7a524f146a6cfb5c826885eb1a637a54.svg";